import script from "./ArticleSinglePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleSinglePage.vue?vue&type=script&setup=true&lang=js"

import "./ArticleSinglePage.vue?vue&type=style&index=0&id=42d77b81&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d77b81"]])

export default __exports__